import api from '@/services/api/api';

export const useDatesCategories = () => {
  const datesCategories = useQuery(
    ['datesCategories'],
    async () => {
      const { data } = await api.dates.getDatesCategories();

      return data;
    },
    {
      staleTime: Infinity,
      select: ({ data }) => data,
    },
  );

  onServerPrefetch(async () => {
    await datesCategories.suspense();
  });

  return {
    datesCategories,
  };
};
